import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AuthorizationService } from './services/base/authorization.service';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./pages/authentication/authentication.module').then(m => m.AuthenticationModule),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthorizationService],
    canActivateChild: [AuthorizationService],
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/map/map.module').then(m => m.MapModule),
        data: {
          permissions: [
          ]
        }
      },
      {
        path: 'taken',
        loadChildren: () => import('./pages/tasks/tasks.module').then(m => m.TasksModule),
        data: {
          title: 'Openstaand taken',
          permissions: [
            'tasks.copy',
            'tasks.create',
            'tasks.delete',
            'tasks.closed.edit',
            'tasks.forward',
            'tasks.print',
            'tasks.closed.reopen',
            'tasks.handle',
            'tasks.deleted.read',
            'tasks.unassigned.view',
            'tasks.update',
            'tasks.view',
          ]
        }
      },
      {
        path: 'routering',
        loadChildren: () => import('./pages/routering/routering.module').then(m => m.RouteringModule),
        data: {
          permissions: [
            'routering.actions.manage',
            'routering.categories.manage',
            'routering.departments.manage',
            'routering.roles.manage',
            'routering.sources.manage',
            'routering.tiles.manage',
            'routering.users.audit-logs.manage',
            'routering.users.manage',
            'routering.users.permissions.manage',
          ]
        }
      },
      {
        path: 'instellingen',
        loadChildren: () => import('./pages/configuration/configuration.module').then(m => m.ConfigurationModule),
        data: {
          permissions: [
            'configuration.address-book.manage',
            'configuration.changelogs.manage',
            'configuration.email-templates.manage',
            'configuration.faq.manage',
            'configuration.history-types.manage',
            'configuration.holidays.manage',
            'configuration.priority.manage',
            'configuration.standard-reactions.manage',
            'configuration.statuses.manage',
          ]
        }
      },
      {
        path: 'handleiding',
        loadChildren: () => import('./pages/knowledge-base/knowledge-base.module').then(m => m.KnowledgeBaseModule),
      },
      {
        path: 'sent-emails',
        loadChildren: () => import('./pages/sent-emails/sent-emails.module').then(m => m.SentEmailsModule),
        data: {
          permissions: [],
        }
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: '/'
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledNonBlocking',
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
//    relativeLinkResolution: 'legacy'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
